export const MOCK_DATA=[
    {
        "subName": "Abonament Free",
        "subActivDate": "2023-05-01T08:00:00Z",
        "subUserNumb": "25000",
        "subsPrice": "0",
        "userName": "John Doe",
        "creationDate": "2023-05-01T08:00:00Z",
        "subscriptionType": "Free",
        "subscriptionStatus": "2025-05-01T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "52",
        "issuDate": "2023-05-01T08:00:00Z",
        "messageName": "Wiadomość powitalna",
        "messageTemplate": "Wiadomość powitalna",
        "messagesRecipients": "12000",
        "messageEmail": "adres@email.com",
        "deviceName": "EWFEE1",
        "deviceID": "YDDPWO9V",
        "deviceType": "karta",
        "Lp": 1,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"
    },
    {
        "subName": "Abonament PRO",
        "subActivDate": "2023-05-01T08:00:00Z",
        "subUserNumb": "12000",
        "subsPrice": "50",
        "userName": "Jane Smith",
        "creationDate": "2023-05-02T08:00:00Z",
        "subscriptionType": "Pro",
        "subscriptionStatus": "2024-06-07T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "52",
        "issuDate": "2023-01-01T08:00:00Z",
        "messageName": "Przypomnienie o zmianach regulaminu",
        "messageTemplate": "Przypomnienie o zmianach regulaminu",
        "messagesRecipients": "14000",
        "messageEmail": "adres@email.com",
        "deviceName": "WC9AK6",
        "deviceID": "WCFU51DJ",
        "deviceType": "brelok",
        "Lp": 2,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"

    },
    {
        "subName": "Abonament PRO1",
        "subActivDate": "2023-01-01T08:00:00Z",
        "subUserNumb": "12000",
        "subsPrice": "50",
        "userName": "Alice Johnson",
        "creationDate": "2023-08-01T08:00:00Z",
        "subscriptionType": "Pro",
        "subscriptionStatus": "2024-06-01T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "95",
        "issuDate": "2023-05-01T08:00:00Z",
        "messageName": "Zmiana ceny za abonament pro",
        "messageTemplate": "Zmiana ceny za abonament pro",
        "messagesRecipients": "12000",
        "messageEmail": "adres@email.com",
        "deviceName": "8MNUVH",
        "deviceID": "KJYMVYU4",
        "deviceType": "karta",
        "Lp": 3,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"

    },
    {
        "subName": "Abonament Free",
        "subActivDate": "2023-01-01T08:00:00Z",
        "subUserNumb": "12000",
        "subsPrice": "50",
        "userName": "John Doe",
        "creationDate": "2023-05-01T08:00:00Z",
        "subscriptionType": "Free",
        "subscriptionStatus": "2024-05-27T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "52",
        "issuDate": "2023-01-01T08:00:00Z",
        "messageName": "Nowa funkcja w abonamencie pro",
        "messageTemplate": "Nowa funkcja",
        "messagesRecipients": "10000",
        "messageEmail": "adres@email.com",
        "deviceName": "X751JH",
        "deviceID": "FMTM0225",
        "deviceType": "karta",
        "Lp": 4,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"

    },
    {
        "subName": "Abonament PRO1",
        "subActivDate": "2023-01-01T08:00:00Z",
        "subUserNumb": "12000",
        "subsPrice": "50",
        "userName": "Alice Johnson",
        "creationDate": "2023-08-01T08:00:00Z",
        "subscriptionType": "Pro",
        "subscriptionStatus": "2024-06-01T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "95",
        "issuDate": "2023-05-01T08:00:00Z",
        "messageName": "Zmiana ceny za abonament pro",
        "messageTemplate": "Zmiana ceny za abonament pro",
        "messagesRecipients": "12000",
        "messageEmail": "adres@email.com",
        "deviceName": "8MNUVH",
        "deviceID": "KJYMVYU4",
        "deviceType": "karta",
        "Lp": 10,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"

    },
    {
        "subName": "Abonament Free",
        "subActivDate": "2023-01-01T08:00:00Z",
        "subUserNumb": "12000",
        "subsPrice": "50",
        "userName": "John Doe",
        "creationDate": "2023-05-01T08:00:00Z",
        "subscriptionType": "Free",
        "subscriptionStatus": "2024-05-27T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "52",
        "issuDate": "2023-01-01T08:00:00Z",
        "messageName": "Nowa funkcja w abonamencie pro",
        "messageTemplate": "Nowa funkcja",
        "messagesRecipients": "10000",
        "messageEmail": "adres@email.com",
        "deviceName": "X751JH",
        "deviceID": "FMTM0225",
        "deviceType": "karta",
        "Lp": 4,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"

    },
    {
        "subName": "Abonament PRO1",
        "subActivDate": "2023-01-01T08:00:00Z",
        "subUserNumb": "12000",
        "subsPrice": "50",
        "userName": "Alice Johnson",
        "creationDate": "2023-08-01T08:00:00Z",
        "subscriptionType": "Pro",
        "subscriptionStatus": "2024-06-01T08:00:00Z",
        "transDate": "2023-02-01T08:00:00Z",
        "transValue": "95",
        "issuDate": "2023-05-01T08:00:00Z",
        "messageName": "Zmiana ceny za abonament pro",
        "messageTemplate": "Zmiana ceny za abonament pro",
        "messagesRecipients": "12000",
        "messageEmail": "adres@email.com",
        "deviceName": "8MNUVH",
        "deviceID": "KJYMVYU4",
        "deviceType": "karta",
        "Lp": 10,
        "address":"00-000 Miejscowość, Ul. Nazwa 0"

    }
]


